module.exports = __webpack_public_path__ + "img/Logo-34.9ca78968.svg";